// extracted by mini-css-extract-plugin
export default {"title":"_9MdY6___Listings-module__title","cardList":"sHB24___Listings-module__cardList"};